module.exports = "REGISTER\n"